import api from '../api'

export async function getAllows() {
  return api.get('terms/allows');
}

export async function getAllVersions(numOfRegisters = 10, page = 1, order) {
  const params = {
    order: order ? order : 'url',
  }
  return api.get('terms', {
    params,
    headers: {
      registerperpage: numOfRegisters,
      page
    }
  });
}

export async function getVersion(id) {
  return api.get(`terms/${id}`);
}

export async function putVersion(id, version) {
  return api.put(`terms/${id}`, version);
}

export async function postVersion(version) {
  return api.post(`terms/`, version);
}

export async function deleteVersion(id) {
  return api.delete(`terms/${id}`);
}